import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from '@spaced-out/ui-design-system/lib/components/Dialog';
import {
  BodyLarge,
  SubTitleLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';


type DeleteTaskConfirmationDialogProps = {
  isOpen: boolean;
  isDeleting?: boolean;
  onClose: (event: React.SyntheticEvent) => void;
  onConfirm: (event: React.SyntheticEvent) => void;
};

export const DeleteTaskConfirmationDialog = ({
  isOpen,
  isDeleting = false,
  onClose,
  onConfirm,
}: DeleteTaskConfirmationDialogProps) => {
  const {t} = useLabelTranslation();

  return (
    <Dialog isOpen={isOpen} iconName="list-check" onClose={onClose}>
      <DialogHeader>
        <SubTitleLarge>{t('Delete_Task', 'Delete Task')}</SubTitleLarge>
      </DialogHeader>
      <DialogBody>
        <BodyLarge color="secondary">
          {t(
            'Are_you_sure_you_want_to_delete_this_task_This_action_cannot_be_undone',
            'Are you sure you want to delete this task? This action cannot be undone.',
          )}
        </BodyLarge>
      </DialogBody>
      <DialogFooter>
        <Button
          isFluid
          type="tertiary"
          onClick={onClose}
          testId="task-delete-dialog-cancel"
        >
          {t('Cancel', 'Cancel')}
        </Button>
        <Button
          isFluid
          type="primary"
          onClick={onConfirm}
          isLoading={isDeleting}
          testId="task-delete-dialog-confirm"
        >
          {t('Delete', 'Delete')}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
